<template>
    <div class="body">
        <!-- 导航栏 -->
        <mslNav></mslNav>
        <!-- 产品分类 -->
        <div class="sort space_center" :class="[ showSort ? '' : 't_0']">
            <div class="item left_center" @click="showPopup">
                <span class="txt"> {{ isSelect ? selectName : '请选择分类' }} </span>
                <span class="iconfont iconicon-09 xiajiantou"></span>
            </div>
        </div>
        <div class="distance"></div>
        <div class="s_sort" :class="[ showSort ? '' : 'top_50']">
            <div class="a_content" v-if="show">
                <div class="s_list">
                    <div class="s_item ta_left" @click="swiperItem(item.id, item.cate_name)" v-for="item in sortList" :key="item.id">{{
                        item.cate_name }}
                    </div>
                </div>
            </div>
            <div class="s_mark" @click="closeFn" v-if="show"></div>
        </div>

        <!-- 产品分类 -->
        <div class="list flex flex-dir-left flex-wrap">
            <router-link :to="{ name: 'production_detail', query: { id: item.id } }" class="td_none item" v-for="(item, index) in list" :key="index">
                <div class="">
                    <div class="img_box">
                        <img :src="[ item.image ? item.image : img ]" alt="">
                    </div>
                    <div class="content w">
                        <div class="i_title w d_ellipsis ta_center">{{ item.store_name }}</div>
                        <div class="price ta_center">{{ '￥' + item.price }}</div>
                    </div>
                </div>
            </router-link>
        </div>
        <noData v-if="list && list.length == 0 && loadingType === 0"></noData>
        <div class="load_area row_center" v-if="loadingType !=0">
            <div class="load_more row_center" v-if="loadingType === 1" @click="getList('load')">
                加载更多
            </div>
            <div class="loading left_center" v-if="loadingType === 2">
                <van-loading/>
                <span class="load_txt">加载中...</span>
            </div>
            <div class="no_more" v-if="loadingType === 3">已加载全部内容</div>
        </div>
    </div>
</template>

<script>
    import {proList, proSort, baseInfo} from '../api/common.js'
    import noData from '../components/no_data'

    let old_scroll = 0;
    export default {
        name: "production",
        components: {
            noData
        },
        data() {
            return {
                isSelect: false,
                selectName: '',
                sortList: [],
                show: false,
                showSort: true,
                scroll: 0, // 滚动高度
                old_scroll: 0, // 滚动高度（旧）
                baseInfo: {},
                list: [],
                loadingType: 1, // 加载按钮 =》 1； 加载中 =》 2； 全部加载 =》 3
                formData: {
                    page: 1,
                    limit: 8,
                    cate_id: null
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
            this.getList('init');
            this.getProSort(); // 获取分类列表
        },
        methods: {
            // 列表
            async getList(type) {
                try {
                    // 显示加载中；
                    this.loadingType = 2;
                    // 赋值
                    let list = this.list;
                    // 调用接口；
                    let res = await proList(this.formData);
                    if (res.code == 1) {
                        // 初始化？ 加载中？
                        if (type == 'init') {
                            list = res.data.list;
                        } else if (type == 'load') {
                            list = list.concat(res.data.list);
                        }
                        // 加载完成？
                        if (res.data.list && res.data.list.length < 8) {
                            this.loadingType = 3;
                        } else {
                            this.loadingType = 1;
                        }
                        // 初始化 没有数据
                        if (res.data.list.length === 0 && data.page === 1) {
                            this.loadingType = 0; // 隐藏全部加载
                        }
                        this.formData.page++;
                        this.list = list;
                    }
                } catch {
                    this.errToast('加载数据失败，请刷新');
                }
            },

            // 打开弹窗
            showPopup() {
                this.show = !this.show;
            },

            // 关闭弹窗
            closeFn() {
                this.show = false;
            },

            // 分类
            getProSort() {
                try {
                    proSort().then(res => {
                        console.log(res, '产品分类');
                        if (res.code == 1) {
                            this.sortList = res.data.cateogry
                            this.sortList.unshift({
                                cate_name: '全部',
                                cate_id: null
                            })
                        }
                    })
                } catch {
                    this.$message.error('加载数据失败，请刷新');
                }
            },

            // 关闭弹窗 调用接口
            swiperItem(cate_id, name) {
                this.show = false;
                this.selectName = name;
                this.isSelect = true;
                this.getSortProList(cate_id);
            },

            // 调用接口
            getSortProList(id) {
                this.formData.cate_id = id;
                this.formData.page = 1;
                this.getList('init');
            },

            // 样式
            handleScroll() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (this.scroll > 20) {
                    this.toggerNavStatus();
                } else {
                    this.showSort = true;
                }
                this.old_scroll = this.scroll;
            },

            // 样式
            toggerNavStatus() {
                this.showSort = this.scroll > this.old_scroll ? false : true;
            },

        }
    }
</script>

<style scoped lang="scss">
    .t_0 {
        top: 0 !important;
        transition: top 0.3s linear;
        -moz-transition: top 0.3s linear; /* Firefox 4 */
        -webkit-transition: top 0.3s linear; /* Safari å’Œ Chrome */
        -o-transition: top 0.3s linear; /* Opera */
    }

    .top_50 {
        top: 50px !important;
        transition: top 0.3s linear;
        -moz-transition: top 0.3s linear; /* Firefox 4 */
        -webkit-transition: top 0.3s linear; /* Safari å’Œ Chrome */
        -o-transition: top 0.3s linear; /* Opera */
    }

    .distance {
        width: 100%;
        height: 50px;
    }

    .s_sort {
        position: fixed;
        top: 100px;
        z-index: 15;
        transition: top 0.3s linear;
        -moz-transition: top 0.3s linear; /* Firefox 4 */
        -webkit-transition: top 0.3s linear; /* Safari å’Œ Chrome */
        -o-transition: top 0.3s linear; /* Opera */
        .s_mark {
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, .6);
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
        }

        .a_content {
            border-top: 1px solid #f2f2f4;
            width: 100vw;
            /*height: 200px;*/
            position: absolute;
            background-color: #fff;
            top: 0;
            left: 0;
            z-index: 200;

            .s_list {
                width: 100%;
                padding: 0 16px;
                box-sizing: border-box;

                .s_item {
                    padding: 12px 0;
                    box-sizing: border-box;
                    width: 100%;
                    border-bottom: 1px solid #f2f2f4;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 24px;
                    color: #262626;
                    /*&:last-child {*/
                    /*    border-bottom: 0;*/
                    /*}*/
                }
            }
        }
    }

    .h_200 {
        height: 200px;
    }

    .h_0 {
        height: 0;
    }

    /*.s_popup {*/
    /*    */
    /*}*/
    .sort {
        width: 100%;
        height: 50px;
        background-color: #fff;
        padding: 0 16px;
        box-sizing: border-box;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06);
        position: fixed;
        top: 50px;
        transition: top 0.3s linear;
        -moz-transition: top 0.3s linear; /* Firefox 4 */
        -webkit-transition: top 0.3s linear; /* Safari å’Œ Chrome */
        -o-transition: top 0.3s linear; /* Opera */
        /*top:0px;*/
        /*top: 50px;*/
        .item {
            .txt {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                line-height: 24px;
                color: #262626;
            }

            .xiajiantou {
                font-size: 24px;
                color: #bfbfbf;
                margin-left: 4px;
            }
        }
    }

    .list {
        margin-top: 12px;
        padding: 0 16px;
        box-sizing: border-box;

        .item {
            width: 48%;
            margin-right: 4%;
            margin-bottom: 15px;

            &:nth-child(2n) {
                margin-right: 0;
            }

            &:nth-last-child(1), &:nth-last-child(2) {
                margin-bottom: 0;
            }

            .img_box {
                width: 100%;
                height: 164px;
                overflow: hidden;
            }

            img {
                width: 100%;
                height: 100%;
            }

            .content {
                margin-top: 8px;

                .i_title {
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 20px;
                    color: #262626;
                }

                .price {
                    margin-top: 4px;
                    font-size: 14px;
                    font-family: SF Pro Display;
                    font-weight: 800;
                    line-height: 16px;
                    color: #262626;
                }
            }
        }
    }

    .load_area {
        margin-top: 32px;
        margin-bottom: 60px;

        .load_more {
            width: 89px;
            height: 34px;
            border: 1px solid rgba(38, 38, 38, .8);
            border-radius: 2px;
            margin-right: 20px;
            font-size: 14px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            line-height: 20px;
            color: rgba(38, 38, 38, .8);
        }

        .no_more {
            color: rgba(38, 38, 38, .8);
            font-size: 12px;
        }

        .loading {
            .load_txt {
                color: rgba(38, 38, 38, .5);
                font-size: 12px;
                margin-left: 12px;
            }
        }
    }
</style>
